module.exports = __webpack_public_path__ + "static/media/45.302319d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/45.wav
// module id = Wl9g
// module chunks = 0